var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progressbar",class:{'progressbar__stripes': _vm.waiting || _vm.value===null}},[_c('div',{staticClass:"progressbar__p",style:({width: _vm.widthpct})})])}
var staticRenderFns = []

export { render, staticRenderFns }